import { setModulousId } from '../functions/set-modulous-id.js';
import { uuidV4 } from '../../util/others/uuid-v4.js';

function RgCreate(config, rvDataList) {
    const obj = {
        name: '',
        uuid: uuidV4(),
        pos: [0, 0, 0],
        rot: [0, 0, 0],
        size: [0, 0, 0],
        anchor: [0, 0, 0],
        color: '#cccccc',
        alpha: 1,
        rg: true,
        ...config,
        children: []
    };
    if (obj.data) {
        obj.data = { ...obj.data };
    }
    obj.anchor = obj.anchor.slice();
    obj.pos = obj.pos.slice();
    obj.rot = obj.rot.slice();
    obj.size = obj.size.slice();
    setModulousId({ obj, modulousId: obj.modulousId, rvDataList });
    for (const c of config.children) {
        const child = RgCreate(c, rvDataList);
        child.parent = obj;
        obj.children.push(child);
    }
    return obj;
}

export { RgCreate };
//# sourceMappingURL=rg-create.js.map
